/*
*
*	extendFormHelper by adding erube.js "-label" highlighting
*	formhelper.label.js
*
*/
(function(formHelper, $, undefined) {

	// alert('formhelper.label.js');

	// Save copies of the functions that make errors appear and disappear...
	formHelper.FormHelperRequest.prototype._getErroredControls    = formHelper.FormHelperRequest.prototype.getErroredControls;
	formHelper.FormHelperRequest.prototype._clearAllErroredFields = formHelper.FormHelperRequest.prototype.clearAllErroredFields;

	// create new functions that do new stuff + what the old functions did...
	formHelper.FormHelperRequest.prototype.getErroredControls = function() {

		// Then look for "FORMID-label" elements and do old school erube.js style error classing
		var errors    = this.errors;
		if (errors && errors.length) {
			$(errors).each(function(index, error) {
				if (error.params) {
					$(error.params).each(function(index, param) {
						$('#' + param + '-label').addClass('error').addClass('eRubeSubmitAuto');
					});
				}
			});
		}
		return this._getErroredControls();
	}

	formHelper.FormHelperRequest.prototype.clearAllErroredFields = function () {
		
		// First do what formhelper normally does
		this._clearAllErroredFields();

		// Then look for old school erube.js style error classes and remove them.
		$('.' + 'eRubeSubmitAuto').removeClass('error eRubeSubmitAuto');
	}

})(window.formHelper = window.formHelper || {}, jQuery);
